export const buildVersion = parseFloat(`${process.env.APP_VERSION}`) || 0;

export const getConfigString = (name: string) =>
  document.head.querySelector(`meta[name="${name}"]`)?.getAttribute('content') || '';

export const TEST = typeof TEST_BUILD !== 'undefined' && TEST_BUILD;
